import { setupLocale } from "../localizationManager";

export var portugueseStrings = {
  // "Group By Me"
  groupButton: "Agrupar Por Mim",
  // "Ungroup By Me"
  ungroupButton: "Desagrupar Por Mim",
  // "Select Me"
  selectButton: "Selecionar",
  // "Hide column"
  hideColumn: "Esconder coluna",
  // "Show column"
  showColumn: "Mostrar coluna",
  // "Make column private"
  makePrivateColumn: "Tornar coluna privada",
  // "Make column public"
  makePublicColumn: "Tornar coluna pública",
  // "Move to Detail"
  moveToDetail: "Mover para Detalhes",
  // "Show as Column"
  showAsColumn: "Mostrar como Coluna",
  // "Search..."
  filterPlaceholder: "Pesquisar...",
  // "Remove rows"
  removeRows: "Remover linhas",
  // "Show"
  showLabel: "Mostrar",
  // "entries"
  entriesLabel: "entradas",
  // "Texts in table"
  visualizer_text: "Textos em tabela",
  // "Wordcloud"
  visualizer_wordcloud: "Nuvem de palavras",
  // "Histogram"
  visualizer_histogram: "Histograma",
  // "Average"
  visualizer_number: "Média",
  // "Table"
  visualizer_choices: "Tabela",
  // "Chart"
  visualizer_selectBase: "Gráfico",
  // [Auto-translated] "Chart"
  visualizer_matrix: "Gráfico",
  // [Auto-translated] "Bar"
  chartType_bar: "Barra",
  // "Vertical Bar"
  chartType_vbar: "Barra vertical",
  // "Stacked Bar"
  chartType_stackedbar: "Barra Empilhada",
  // "Doughnut"
  chartType_doughnut: "Rosca",
  // "Pie"
  chartType_pie: "Tarte",
  // "Scatter"
  chartType_scatter: "Lastro",
  // "Gauge"
  chartType_gauge: "Escala",
  // "Bullet"
  chartType_bullet: "Bala",
  // [Auto-translated] "Line"
  chartType_line: "Linha",
  // [Auto-translated] "Radar"
  chartType_radar: "Radar",
  // "Hide"
  hideButton: "Esconder",
  // "Make private"
  makePrivateButton: "Tornar privado",
  // "Make public"
  makePublicButton: "Tornar público",
  // "Show"
  showButton: "Mostrar",
  // "Filter"
  filter: "Filtrar",
  // "Reset Filter"
  resetFilter: "Restaurar Filtro",
  // "Change Locale"
  changeLocale: "Mudar Localização",
  // "Clear"
  clearButton: "Limpar",
  // "Choose question to show..."
  addElement: "Escolher questão para mostrar...",
  // "Default Order"
  defaultOrder: "Ordenação Padrão",
  // "Ascending"
  ascOrder: "Ascendente",
  // "Descending"
  descOrder: "Descendente",
  // "Show minor columns"
  showMinorColumns: "Mostrar colunas menores",
  // [Auto-translated] "Actions"
  actionsColumn: "Ações",
  // "Other items and comments"
  otherCommentTitle: "Outros itens e comentários",
  // "Show percentages"
  showPercentages: "Mostrar percentuais",
  // "Hide percentages"
  hidePercentages: "Esconder percentuais",
  // "PDF"
  pdfDownloadCaption: "PDF",
  // "Excel"
  xlsxDownloadCaption: "Excel",
  // "CSV"
  csvDownloadCaption: "CSV",
  // "Download plot as a PNG file"
  saveDiagramAsPNG: "Baixar diagrama como PNG",
  // "Hide empty answers"
  hideEmptyAnswers: "Esconder perguntas vazias",
  // "Show empty answers"
  showEmptyAnswers: "Mostrar perguntas vazias",
  // "All answers"
  "topNValueText-1": "Todas as respostas",
  // "Top 5 answers"
  topNValueText5: "Primeiras 5 respostas",
  // "Top 10 answers"
  topNValueText10: "Primeiras 10 respostas",
  // "Top 20 answers"
  topNValueText20: "Primeiras 20 respostas",
  // "Hide missing answers"
  hideMissingAnswers: "Ocultar perguntas não respondidas",
  // "Show missing answers"
  showMissingAnswers: "Mostrar perguntas não respondidas",
  // "Missing answers"
  missingAnswersLabel: "Perguntas não respondidas",
  // "This question type is not visualized yet"
  noVisualizerForQuestion: "Este tipo de pergunta ainda não foi visualizada",
  // "There are no results yet"
  noResults: "Ainda não possui resultados",
  // "Per Values"
  showPerValues: "Por valores",
  // "Per Columns"
  showPerColumns: "Por colunas",
  // "Answer"
  answer: "Resposta",
  // "Correct answer: "
  correctAnswer: "Resposta correta: ",
  // "Percent"
  percent: "Percentagem",
  // [Auto-translated] "Percentage"
  percentage: "Porcentagem",
  // [Auto-translated] "Chart"
  statistics_chart: "Gráfico",
  // "Responses"
  responses: "Respostas",
  // [Auto-translated] "NPS"
  visualizer_nps: "NPS",
  // [Auto-translated] "Chart"
  visualizer_boolean: "Gráfico",
  // [Auto-translated] "Table"
  visualizer_options: "Mesa",
  // [Auto-translated] "NPS"
  npsScore: "NPS",
  // [Auto-translated] "Promoters"
  npsPromoters: "Promotores",
  // [Auto-translated] "Passives"
  npsPassives: "Passivos",
  // [Auto-translated] "Detractors"
  npsDetractors: "Detratores",
  // [Auto-translated] "Category (X Axis):"
  axisXSelectorTitle: "Categoria (eixo X):",
  // [Auto-translated] "Legend (Series):"
  axisYSelectorTitle: "Lenda (Série):",
  // [Auto-translated] "Segments:"
  axisXAlternativeSelectorTitle: "Segmentos:",
  // [Auto-translated] "Groups:"
  axisYAlternativeSelectorTitle: "Grupos:",
  // [Auto-translated] "Not selected"
  notSelected: "Não selecionado",
  // [Auto-translated] "Default"
  intervalMode_default: "Inadimplência",
  // [Auto-translated] "Decades"
  intervalMode_decades: "Décadas",
  // [Auto-translated] "Years"
  intervalMode_years: "Anos",
  // [Auto-translated] "Quarters"
  intervalMode_quarters: "Quartos",
  // [Auto-translated] "Months"
  intervalMode_months: "Meses",
  // [Auto-translated] "Days"
  intervalMode_days: "Dias",
  // [Auto-translated] "Custom"
  intervalMode_custom: "Costume",
  // [Auto-translated] "Auto"
  intervalMode_auto: "Automático",
  // [Auto-translated] "Intervals:"
  intervalModeTitle: "Intervalos:",
  // [Auto-translated] "Show individual values"
  noRunningTotals: "Mostrar valores individuais",
  // [Auto-translated] "Show running totals"
  runningTotals: "Mostrar totais acumulados",
  // [Auto-translated] "Compare periods"
  groupDateSeries: "Comparar períodos",
  // [Auto-translated] "View timeline"
  ungroupDateSeries: "Ver linha do tempo",
  // [Auto-translated] "None"
  noneAggregateText: "Nenhum",
  // [Auto-translated] "Aggregate:"
  selectAggregateText: "Agregado:",
  // [Auto-translated] "Year ends with"
  groupedYearsAxisTitle: "O ano termina com"
};

setupLocale({ localeCode: "pt", strings: portugueseStrings, nativeName: "Português" });